import FileCopy from "@mui/icons-material/FileCopy";
import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;

	> h2 {
		font-weight: bold;
	}
`;

export const Header = styled.div`
	position: relative;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const RowInputs = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 1rem;
	margin-bottom: 1rem;

	@media (max-width: 560px) {
		grid-template-columns: 1fr;
	}
`;

export const DateContainer = styled.div`
	display: flex;
	background: #fff;
	border-radius: 0.5rem;

	align-items: center;
	justify-content: space-around;

	& .MuiFormControl-root {
		width: 48%;
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
		max-height: 48px;
	}

	@media (max-width: 560px) {
		flex-direction: column;
		& .MuiFormControl-root {
			width: 100%;
			margin: 0.25rem 0rem;
		}
	}
`;

export const IconButtonFile = styled(FileCopy)`
	color: ${({ theme }) => theme.icon};
	cursor: pointer;
`;

export const TooltipText = styled.p`
	margin: 0;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	width: 100%;
	max-width: 300px;
`;

export const StyledTableCell = styled.div`
	max-width: 35px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;
